import { REDUCER_NAME } from './const'

export const selectOwnState = (state) => {
    return state[REDUCER_NAME]
}

export const selectRefinementReason = (state) => {
    return selectOwnState(state).refinementReason
}

export const selectHasChanged = state => {
    return selectOwnState(state).hasChanged
}



// WEBPACK FOOTER //
// ./src/modules/refinement/state/selector.js